import { render, staticRenderFns } from "./centerRight2.vue?vue&type=template&id=c2eb9cc4&scoped=true"
import script from "./centerRight2.vue?vue&type=script&lang=js"
export * from "./centerRight2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2eb9cc4",
  null
  
)

export default component.exports